import axios from 'axios';
import AppConfig from "../../AppConfig";

let URL = AppConfig.HOST_API() + 'lpp/'

export default {

    pobierzOdbiciaPoprawne(dataOd, dataDo){
        return axios({
            method: 'get',
            url: URL+`odbicia?dataOd=${dataOd}&dataDo=${dataDo}&poprawne=true`
        })
    },

    pobierzOdbiciaNiePoprawne(dataOd, dataDo){
        return axios({
            method: 'get',
            url: URL+`odbicia?dataOd=${dataOd}&dataDo=${dataDo}&poprawne=false`
        })
    },

}


// WEBPACK FOOTER //
// ./src/modules/lpp/LppService.js